// extracted by mini-css-extract-plugin
module.exports = {"componentsSmsCode":"styles_componentsSmsCode__33P0J","sendBtn":"styles_sendBtn__1LSJw"};